module.exports = __webpack_public_path__ + "img/Asset_SINPE_IBAN.00c5c036.jpg";